import { TextField, Typography } from '@mui/material';
import { ChangeEvent, FocusEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';

export enum OwnSharesType {
  Currency = 'currency',
  Percentage = 'percentage',
}

interface OwnSharesFieldProps {
  value: string;
  type: OwnSharesType;
  currency: string;
  error?: boolean;
  helperText?: string;
  onBlur: (event: FocusEvent<HTMLInputElement>) => void;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const OwnSharesField = ({
  value,
  type,
  currency,
  error,
  helperText,
  onBlur,
  onChange,
}: OwnSharesFieldProps) => {
  const { t } = useTranslation();

  if (type === OwnSharesType.Percentage) {
    return (
      <TextField
        fullWidth
        label={t('own_shares')}
        name="own_shares"
        type="number"
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        error={error}
        slotProps={{
          input: {
            endAdornment: (
              <Typography variant="body2" color="text.disabled">
                %
              </Typography>
            ),
          },
          htmlInput: {
            min: 1,
            max: 100,
            step: 0.01,
          },
        }}
        helperText={helperText}
      />
    );
  }

  return (
    <NumericFormat
      fullWidth
      customInput={TextField}
      label={t('own_shares')}
      name="own_shares"
      type="text"
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      error={error}
      slotProps={{
        input: {
          endAdornment: (
            <Typography variant="body2" color="text.disabled">
              {currency}
            </Typography>
          ),
        },
        htmlInput: {
          min: 0,
        },
      }}
      helperText={helperText}
      thousandSeparator={' '}
      decimalSeparator=","
      allowedDecimalSeparators={[',', '.']}
      decimalScale={2}
      fixedDecimalScale={true}
    />
  );
};
